<h1 mat-dialog-title>{{ data.dialog_title }}</h1>

<mat-dialog-content>
  <mat-radio-group [ngModel]="value" (ngModelChange)="value = $event">
    @for (row of data.data; track row) {
      <mat-radio-button [value]="row.value">{{ row.textToShow }}</mat-radio-button>
    }
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ data.dialog_cancel_button }}</button>
  <button mat-flat-button color="accent" (click)="submit()" [disabled]="value == null">{{ data.dialog_ok_button }}</button>
</mat-dialog-actions>
